import BookingEditForm from 'components/forms/BookingFormFactory/BookingEditForm';
import { ModalBase, PriceDisplay } from 'remote/global';
import { useOperatorsOrdersQuery } from 'api/queries/operators';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  onClose: () => void;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isOrderEditAvailable: boolean;
  bookingNumber: string;
  rideId: number;
};

function OrderEditModal({
  open,
  setOpen,
  onClose,
  bookingNumber,
  isOrderEditAvailable,
  rideId,
}: Props) {
  const orderQuery = useOperatorsOrdersQuery(open ? bookingNumber : undefined);
  const { t } = useTranslation();
  const { data: order, isLoading } = orderQuery;

  const selectedRide = order?.rides.find((ride) => ride.id === rideId);
  const rideNumber = selectedRide?.rideNumber;
  const groupNumber = selectedRide?.groupNumber;

  if (isLoading || !order || !selectedRide) return null;

  return (
    <ModalBase
      open={open}
      setOpen={setOpen}
      onClose={onClose}
      maxWidth='md'
      fullWidth
      title={`#${bookingNumber}${
        order.rides.length > 1 && rideNumber != null
          ? ` · ${t('terms.attributes.ride.rideNo', { rideNo: rideNumber })}${
              groupNumber != null
                ? ` · ${t('terms.attributes.ride.groupNo', { groupNo: groupNumber })}`
                : ''
            }`
          : ''
      }`}
      header={{
        children: (
          <PriceDisplay
            priceExclVat={order.operatorPriceExclVat}
            priceInclVat={order.operatorPriceInclVat}
            unadjustedPriceExclVat={order.unadjustedPriceExclVat}
            unadjustedPriceInclVat={order.unadjustedPriceInclVat}
            currency={order.currency}
          />
        ),
      }}
    >
      <BookingEditForm
        orderQuery={orderQuery}
        isOrderEditAvailable={isOrderEditAvailable}
        rideId={rideId}
        onClose={onClose}
      />
    </ModalBase>
  );
}

export default OrderEditModal;
